// extracted by mini-css-extract-plugin
export default {"blog":"Blog_blog__fRo5B","title":"Blog_title__9tnBY","bg":"Blog_bg__ntfGg"};